/**
 * A square initials avatar (DESIGN.md "Shapes": the mockups draw avatars as
 * 32px squares, D39). `tenant` is Soft Green initials on the iuvo navy, a
 * brand pairing (D19); `user` is primary text on layer-selected. Decorative
 * unless given a `label`, because a name always sits beside it.
 */
import clsx from 'clsx'
import type { AvatarProps } from './types'

const TONE: Record<AvatarProps['tone'], string> = {
  tenant: 'bg-[color:var(--avatar-navy)] text-interactive',
  user: 'bg-layer-selected text-text-primary',
}

const SIZE: Record<NonNullable<AvatarProps['size']>, string> = {
  24: 'h-6 w-6 text-[10px]',
  32: 'h-8 w-8 text-helper',
  40: 'h-10 w-10 text-body',
}

export function Avatar({ initials, tone, size = 32, label, className }: AvatarProps) {
  return (
    <span
      {...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true })}
      className={clsx('inline-grid flex-none place-items-center font-semibold tracking-[0.32px]', TONE[tone], SIZE[size], className)}
    >
      {initials.slice(0, 2)}
    </span>
  )
}

export default Avatar
